import { Paper, Table, TableBody, TableContainer } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import TaskItem from "./tasks/TaskItem";
import { ProfileContext } from "../../contexts/ProfileContext";
import formatTasks from "../../_utils/formatter/taskFormatter";

const TableTodoCustom = ({ tasks }: any) => {
  const { setTasks } = useContext(ProfileContext);

  function createData(
    index: string,
    name: string,
    check: boolean,
    description: string,
    date: string,
    status: string,
    id: string
  ) {
    return { index, name, check, description, date, status, id };
  }

  const [rows, setRows] = useState<any[]>(
    tasks?.map((task: any, index: number) =>
      createData(
        `#${index + 1}`,
        task.title,
        task.finished,
        task.description,
        task.dueDate,
        task.status,
        task.id
      )
    ) ?? []
  );

  useEffect(() => {
    if (tasks) {
      setRows(
        tasks.map((task: any, index: number) =>
          createData(
            `#${index + 1}`,
            task.title,
            task.finished,
            task.description,
            task.dueDate,
            task.status,
            task.id
          )
        )
      );
    }
  }, [tasks]);

  const handleClick = (taskId: string) => {
    setTasks((prevTasks: any) =>
      formatTasks(
        prevTasks.map((group: any) => ({
          ...group,
          tasks: group.tasks.map((task: any) =>
            task.id === taskId ? { ...task, finished: !task.finished } : task
          ),
        }))
      )
    );
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="todo-table" sx={{ tableLayout: "fixed" }}>
        <TableBody>
          {rows.map((row) => (
            <TaskItem id={row.index} row={row} handleClick={handleClick} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableTodoCustom;
